
import ObjectCard from '../../components/Card/ObjectCard.vue'
import { getCustomTabsList } from './vehicleProviderCardCustomTabs.js'

export default {
  name: 'VehicleProviderCard',
  extends: ObjectCard,
  data: function () {
    return {
      typeKeyLocal: 'deltaOrganization', // @Override
      typeShownLocal: true
    }
  },
  methods: {
    /**
     * ObjectCard
     */
    // @Override
    setObjectType: function (objectTypeKey) {
      // ignore Иначе typeKeyLocal перезапишется
    },
    // @Override
    getRawCustomTabsList: function (config) {
      return getCustomTabsList(config)
    },
    // @Default
    checkUserAccess: function (user, objectAccess) {
      const access = this.getDefaultAccess()

      access.approvalAccess = user.hasOperation('vehicleProvisionApproval') // objectAccess.approval
      access.applicantAccess = user.hasOperation('vehicleProvisionManagement') // objectAccess.management

      const fullAccess = user.hasRole('admin') && user.fullAccess // objectAccess.fullAccess
      access.editPrivate = fullAccess
      access.viewPrivate = fullAccess
      access.fullAccess = fullAccess

      access.viewPublic = true
      access.editPublic = access.approvalAccess || access.applicantAccess

      access.editAny = access.editPublic
      return access
    }
  }
}
